import React from "react";

const BlueCardBg = () => {
  const [isLarge, setIsLarge] = React.useState(window.innerWidth >= 1920);

  React.useEffect(() => {
    const handleResize = () => setIsLarge(window.innerWidth >= 1920);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const width = isLarge ? 416 : 305;
  const height = isLarge ? 225 : 165;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 416 225"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_29_1718)">
        <rect
          width="416"
          height="225"
          rx="16"
          ry="16"
          fill="url(#paint0_radial_29_1718)"
        />

        <circle cx="366" cy="169" r="109" fill="white" fillOpacity="0.2" />
        <circle
          cx="366"
          cy="169"
          r="108.25"
          stroke="url(#paint1_linear_29_1718)"
          strokeOpacity="0.3"
          strokeWidth="1.5"
        />
        <circle cx="332" cy="-44" r="143" fill="white" fillOpacity="0.2" />
        <circle
          cx="332"
          cy="-44"
          r="142.25"
          stroke="url(#paint2_linear_29_1718)"
          strokeOpacity="0.25"
          strokeWidth="1.5"
        />
      </g>
      <defs>
        <radialGradient
          id="paint0_radial_29_1718"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(416 8.49982e-05) rotate(151.593) scale(472.949 369.883)"
        >
          <stop stopColor="#2795F2" />
          <stop offset="1" stopColor="#A4D5F9" />
        </radialGradient>
        <linearGradient
          id="paint1_linear_29_1718"
          x1="272.5"
          y1="223.5"
          x2="334"
          y2="65"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_29_1718"
          x1="199.5"
          y1="-6"
          x2="400.5"
          y2="80.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <clipPath id="clip0_29_1718">
          <rect width="416" height="225" rx="16" ry="16" />
        </clipPath>
      </defs>
    </svg>
  );
};
export default BlueCardBg;
